<template>
    <div>
        <el-dialog title="交易快照" :visible.sync="dialogVisiblepdf" @close="dialogFormVisible" :close-on-click-modal="false"
            :close-on-press-escape="false" width="50%">
            <div id="pdfdata">
                <h3>
                    <div style="margin: 10px 0;">生成时间:{{ getTime() }}</div>
                </h3>
                <table border="1px" cellpadding="10px" class="tablepdf" style="width: 100%;">
                    <!-- <tr>
                        <th>姓名</th>
                        <th>数量</th>
                        <th>租期</th>
                        <th>押金</th>
                        <th>总租金</th>
                        <th>物流单号</th>
                        <th>设备编号</th>
                        <th>商品名称</th>
                        <th>图片</th>
                        <th>身份证正面</th>
                        <th>身份证反面</th>
                    </tr>
                    <tr>
                        <td> {{ data.username }} </td>
                        <td> {{ data.product[0].total_num }} </td>
                        <td> 12 </td>
                        <td> {{ yajin }} </td>
                        <td> {{ data.total_price }} </td>
                        <td> {{ data.express_no }} </td>
                        <td> {{ data.equipment_no }} </td>
                        <td> {{ data.product[0].product_name }} </td>
                        <td> <img style="width: 65px;height: 65px;" :src="data.product[0].image.file_path"></td>
                        <td> <img style="width: 65px;height: 65px;" :src="data.user.sfzpositive"> </td>
                        <td> <img style="width: 65px;height: 65px;" :src="data.user.sfzback"></td>
                    </tr> -->

                    <tr>
                        <th>姓名</th>
                        <td> {{ data.username }} </td>
                    </tr>
                    <tr>
                        <th>数量</th>
                        <td> {{ data.product[0].total_num }} </td>
                    </tr>
                    <tr>
                        <th>租期</th>
                        <td> 12 </td>
                    </tr>
                    <tr>
                        <th>押金</th>
                        <td> {{ yajin }} </td>
                    </tr>
                    <tr>
                        <th>总租金</th>
                        <td>{{ data.total_price }} </td>
                    </tr>
                    <tr>
                        <th>物流单号</th>
                        <td>{{ data.express_no }} </td>
                    </tr>
                    <tr>
                        <th>设备编号</th>
                        <td> {{ data.equipment_no }} </td>
                    </tr>
                    <tr>
                        <th>商品名称</th>
                        <td> {{ data.product[0].product_name }} </td>
                    </tr>
                    <tr>
                        <th>图片</th>
                        <td style="display: flex;justify-content: center;"> <img style="width: 65px;height: 65px;"
                                :src="data.product[0].image.file_path"> </td>
                    </tr>
                    <tr>
                        <th>身份证正面</th>
                        <td style="display: flex;justify-content: center;"> <img style="width: 90px;height: 70px;"
                                :src="data.user.sfzpositive"> </td>
                    </tr>
                    <tr>
                        <th>身份证反面</th>
                        <td style="display: flex;justify-content: center;"> <img style="width: 90px;height: 70px;"
                                :src="data.user.sfzback"> </td>
                    </tr>
                </table>
            </div>
            <div class="pdf"><el-button type="primary" @click="PdfExport()">导出PDF</el-button></div>
        </el-dialog>
    </div>
</template>

<script>
import OrderApi from '@/api/order.js';
export default {
    data() {
        return {
            dialogVisiblepdf: true,
            yajin: 0
        };
    },
    props: ["data"],
    created() {
        let data = this.data.deposit
        if (this.data.auth_no == '') {
            data = 0;
        }
        this.yajin = (Number(data) + Number(this.data.zhuanzujin)).toFixed(2);
    },
    methods: {
        // 获取时间
        getTime() {
            let now = new Date();
            let year = now.getFullYear();
            let month = now.getMonth() + 1;
            let day = now.getDate();
            let hour = now.getHours();
            let minute = now.getMinutes() < 10 ? "0" + now.getMinutes() : now.getMinutes();
            let second = now.getSeconds() < 10 ? "0" + now.getSeconds() : now.getSeconds();
            return `${year}-${month}-${day} ${hour}:${minute}:${second}`
        },
        //点击导出pdf
        PdfExport() {
            const str = document.getElementById('pdfdata').innerHTML;
            window.open("https://shoujizulin.hzrjkf.com/index.php/shop/order.order/createpdf?str=" + str, '_blank')


            // const element = document.getElementById('pdfdata');
            // console.log(element);
            // html2pdf().from(element).save();

            // let Params = {
            //     str: content
            // };
            // OrderApi.createpdf(Params, true)
            //     .then((res) => {
            //         console.log("成功", res);
            //         this.$message({
            //             type: "success",
            //             message: "操作成功",
            //         });
            //     })
            //     .catch((error) => {

            //     });
        },
        /*关闭弹窗*/
        dialogFormVisible() {
            this.$emit('close', { openDialog: false });
        },
        // 过滤器
        formatDate(value) {
            let date = new Date(value * 1000);
            //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM; //月补0
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d; //天补0
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h; //小时补0
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m; //分钟补0
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s; //秒补0
            return y + '-' + MM + '-' + d; //年月日
            // return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s; //年月日时分秒
        },
    }

};
</script>

<style lang="scss">
.time {
    margin: 10px 0;
}

.pdf {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

.tablepdf {
    // width: 100%;

    tr {
        td {
            // height: 100px;
            text-align: center;
            padding: 5px;

            img {
                width: 65px;
                height: 65px;
            }
        }

        .image {
            width: 230px;
        }
    }
}</style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/ExportPDF.vue